import React from "react";
import styles from "./DownloadSection.module.css";
import { Button, Card, CardContent, Typography, Box } from "@mui/material";
import GooglePlay from "./Images/google.png";
import AppStore from "./Images/apple.png";

const DownloadSection = () => {
  return (
    <div className={styles.container}>
      <div className={styles.glow}></div>
      <Box className={styles.textContainer}>
        <Typography variant="h3" className={styles.title}>
          Go Further with <span className={styles.highlight}>Remini</span>
        </Typography>
        <Typography variant="body1" className={styles.subtitle}>
          Revolutionize your creative workflow with Remini AI Tools Suite. From
          generating stunning AI art to crafting captivating videos and
          enhancing.
        </Typography>
        <Card className={styles.downloadCard}>
          <Box className={styles.buttons}>
            <Button className={styles.storeButton}>
              <img
                src={GooglePlay}
                alt="Google Play"
                title="Google Play"
                className={styles.storeImage}
                width="auto"
                height="auto"
                loading="lazy"
                decoding="async"
                aria-describedby="image-caption"
              />
            </Button>
            <Button className={styles.storeButton}>
              <img
                src={AppStore}
                alt="App Store"
                title="App Store"
                className={styles.storeImage}
                width="auto"
                height="auto"
                loading="lazy"
                decoding="async"
                aria-describedby="image-caption"
              />
            </Button>
          </Box>
          <div className={styles.cardGlow}></div>
        </Card>
      </Box>
      <Box className={styles.mockupContainer}>
        <img
          src="https://cdn.web.imagine.art/imagine-frontend/assets/images/landing-page/promotion/image.webp"
          alt="Remini UI"
          title="Remini UI"
          width="auto"
          height="auto"
          loading="lazy"
          decoding="async"
          aria-describedby="image-caption"
          className={styles.mockupImage}
        />
        <div className={styles.imageGlow}></div>
      </Box>
    </div>
  );
};

export default DownloadSection;
